import React from "react";
import { Header } from "./shared/Header";
import { Layout } from "./shared/Layout";
import { Params } from "./shared/Params";
import { Content } from "./shared/Content";
import { Preview } from "./shared/Preview";
import { LeaveConfirm } from "./shared/LeaveConfirm";
import { useContextValue, Context } from "./context";

export const CreateEditSurvey = () => (
  <Context.Provider value={useContextValue()}>
    <Layout>
      <Header />
      <Params />
      <Content />
      <Preview />
    </Layout>
    <LeaveConfirm />
  </Context.Provider>
);
